const PHONE_KEEPING_ZERO = {
  // Indonesia
  "62": [11]
  // Keep leading zero if the phone number length is 11
};
const NO_LEADING_ZERO_CC = /* @__PURE__ */ new Set(["91", "52", "55", "51"]);
const NO_PREFIX_TRIMMING_CC = /* @__PURE__ */ new Set(["55"]);
function getDialingCode(countryDialingCode) {
  return String(countryDialingCode).replace("+", "");
}
const standardizePhoneNumber = (phoneNumber, countryDialingCode) => {
  const cc = getDialingCode(countryDialingCode);
  const digits = phoneNumber.replace(/\D/g, "");
  if (digits.startsWith(cc) && !NO_PREFIX_TRIMMING_CC.has(cc)) {
    const body = digits.slice(cc.length);
    return "+" + cc + body;
  }
  let local = digits;
  if (NO_LEADING_ZERO_CC.has(cc)) {
    return "+" + cc + local;
  }
  if (local[0] === "0" && !shouldKeepLeadingZero(local, cc)) {
    local = local.slice(1);
  }
  return "+" + cc + local;
};
const localizePhoneNumber = (standardizedPhoneNumber, countryDialingCode) => {
  const cc = getDialingCode(countryDialingCode);
  if (standardizedPhoneNumber[0] !== "+") return standardizedPhoneNumber;
  const digits = standardizedPhoneNumber.replace(/\D/g, "");
  if (!digits.startsWith(cc)) return standardizedPhoneNumber;
  const body = digits.slice(cc.length);
  if (NO_LEADING_ZERO_CC.has(cc)) return body;
  let shouldAddLeadingZero = true;
  const phoneConfig = PHONE_KEEPING_ZERO[cc];
  if (phoneConfig) {
    const phoneHasZero = phoneConfig.includes(body.length) && body[0] === "0";
    shouldAddLeadingZero = !phoneHasZero;
  }
  return shouldAddLeadingZero ? "0" + body : body;
};
const shouldKeepLeadingZero = (phoneNumber, countryDialingCode) => {
  var _a;
  const standardizeDialingCode = String(countryDialingCode).replace("+", "");
  const phoneLength = phoneNumber.length;
  const keepLeadingZero = (_a = PHONE_KEEPING_ZERO[standardizeDialingCode]) == null ? void 0 : _a.includes(phoneLength);
  return keepLeadingZero ?? false;
};
export {
  localizePhoneNumber,
  standardizePhoneNumber
};
